export interface IUserAccount {
  userName: string;
  name: string;
  hashedPassword?: number;
  rut: string | null;
  rol?: number;
  isEnabled: boolean;
  email: string;
  profileId: string;
  // role: UserRole;
  profileName: string;
  lastConnection: string;
  expirationTime?: Date;
  //costCentres: number[] | null;
  //driverRuts: string[] | null;
}

export enum UserAccountType {
  Sgi,
  Inspector,
  Driver,
}

export enum UserRole {
  Driver = 'Conductor-GO-COMPLIANCE-WEB',
  SuperUser = 'Administrador del sistema-GO-COMPLIANCE-WEB',
  AdmRRHH = 'Administrativo-GO-COMPLIANCE-WEB',
  Inspector = 'Inspector-GO-COMPLIANCE-WEB',
}

export enum InspectorStatus {
  SUCCESSFULLY_ACTIVATED = 0,
  ALREADY_ACTIVATED,
  ERROR,
}
export interface UserInspectorResource {
  email?: string;
  expirationDate: Date | null;
  status: InspectorStatus | null;
}

export interface HistoryUserInspectorResource {
  connectionDate: string;
  email?: string;
  rutCompany: string;
  companyName: string;
  ipAddress: string;
}
